// src/components/dashboard/DashboardHeader.jsx

import React from 'react';
import { FiPlus } from 'react-icons/fi';

const DashboardHeader = ({ onNewAnalysis }) => {
  return (
    <header className="bg-white border-b border-gray-200 px-4 py-2 flex-shrink-0">
      <div className="flex justify-between items-center">

        {/* Titre + sous-titre sur une seule ligne verticale compacte */}
        <div>
          <h1 className="text-sm font-semibold text-gray-800 leading-tight">
            Tableau de Bord
          </h1>
          <p className="text-[10px] text-gray-400 mt-0.5 leading-none">
            Gérez vos analyses d'opportunités énergétiques
          </p>
        </div>

        {/* Bouton compact */}
        <button
          onClick={onNewAnalysis}
          className="inline-flex items-center px-3 py-1.5 bg-teal-600 text-white
                     rounded-md hover:bg-teal-700 transition-colors
                     text-xs font-medium shadow-sm"
        >
          <FiPlus className="mr-1.5 h-3.5 w-3.5" />
          Nouvelle Analyse
        </button>

      </div>
    </header>
  );
};

export default DashboardHeader;
